module.exports = {"path":["Dashboard","Airticket","Add Records"],"submit":"Submit","update":"Update","reset":"Reset","group":"Add Group","groupEdit":"Edit Group","groupError":"Network Error, can not set up group for this transaction. Try again later."}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/airticket/create/index.json
// module id = y29y
// module chunks = 58